import Vue from 'vue'
import Vuex from 'vuex'

// VP
import venues from './modules/vp/venues'
import activationPlan from './modules/vp/activationPlan'
import users from './modules/vp/users'
import themeProps from './modules/themeProps'
import venueTasks from './modules/vp/venueTasks'
import eodReports from './modules/vp/eodReports'
import personalTodos from './modules/vp/personalTodos'
import venueDrive from './modules/vp/venueDrive'
import regions from './modules/vp/regions'

// Cockpit
import powerBi from './modules/cockpit/powerBi'
import cockpitReports from './modules/cockpit/cockpitReports'

// Marcom
import marcomBooking from './modules/marcom/marcom-booking'
import marcom from './modules/marcom/marcom'

// Campus
import payrates from './modules/campus/payrates'
import venueTrainingSessions from './modules/campus/venueTrainingSessions'
import wizardInstances from './modules/campus/wizardInstances'

// News

// CRM
import cookies from './modules/crm/cookies'
import dynamicForms from './modules/crm/dynamicForms'
import guestProfiles from './modules/crm/guestProfiles'
import emailTemplates from './modules/crm/emailTemplates'
import automations from './modules/crm/automations'
import masterCampaigns from './modules/crm/masterCampaigns'
import venueCampaigns from './modules/crm/venueCampaigns'
import legalDocuments from './modules/crm/legalDocuments'
import guestSegmentation from './modules/crm/guestSegmentation'
import cookiePopup from './modules/crm/cookiePopup'
import chat from './modules/crm/chat'
import email from './modules/crm/engage/email'
import messageTemplates from './modules/crm/messageTemplates'


// Handlebars
import handlebars from './modules/handlebars'



Vue.use(Vuex)

const store = new Vuex.Store({
      state: {
            name: "CampusOnline"
      },
      modules: {
            // Venue portal
            personalTodos,
            venues,
            users,
            activationPlan,
            venueTasks,
            venueTrainingSessions,
            wizardInstances,
            themeProps,
            eodReports,
            venueDrive,
            regions,
            // Cockpit
            cockpitReports,
            powerBi,
            // Marcom
            marcom,
            marcomBooking,
            // Campus
            payrates,
            // News
            // CRM
            cookies,
            guestSegmentation,
            guestProfiles,
            emailTemplates,
            automations,
            masterCampaigns,
            venueCampaigns,
            dynamicForms,
            legalDocuments,
            cookiePopup,
            chat,
            email,
            messageTemplates,
            // Handlebars
            handlebars,
      }
})

export default store
